import React, { Component } from 'react';

export default class Home extends Component {
  render() {
    return (
      <div>        
        <section className="section-home">
          <div>
            <h1>cats cats cats cats cats cats cats cats cats cats cats cats</h1>
          </div>
          <div>
            <h1>cats cats cats cats cats cats cats cats cats cats cats cats</h1>
          </div>
        </section>      
      </div>
    )
  }
}
